import React from 'react';
import { LineChart } from 'react-chartkick';
import { connect } from 'react-redux';

import { selectCurrentSalonCurrencySign } from 'selectors/currentSalon.selectors';
import fixed from 'utils/values/fixed.util';

import 'chartjs-plugin-style';

import Container from '../common/Container';
import LegendContainer from '../common/LegendContainer';

const AvarageBillLineChart = (props) => {
  const { currentSalonSign, name, weekToDate, suffix, data } = props;

  return (
    <Container chartName={name}>
      <LegendContainer
        items={[
          {
            text: 'Week to Date',
            val: `${currentSalonSign}${fixed(weekToDate)}`,
          },
        ]}
      />
      <LineChart
        download
        curve={false}
        prefix={currentSalonSign}
        suffix={suffix}
        data={data}
        colors={['#e3bff5', 'red']}
        dataset={{
          borderWidth: 3,
          pointRadius: 6,
          pointBorderWidth: 3,
          pointBackgroundColor: '#fff',
          pointBorderColor: '#b06cee',
          pointHoverBackgroundColor: '#192340',
          pointHoverBorderColor: '#192340',
          pointHoverBorderWidth: 6,
        }}
        library={{
          animation: { easing: 'easeOutQuad' },
          tooltips: {
            enabled: true,
            backgroundColor: '#192340',
            titleFontSize: 15,
            titleFontStyle: '900',
            titleFontFamily: 'ProximaNova-b',
            titleFontColor: 'white',
            caretSize: 7,
            yPadding: 12,
            xPadding: 14,
            bodyFontFamily: 'ProximaNova-r',
            bodyFontSize: 16,
            borderColor: '#192340',
            shadowOffsetX: 3,
            shadowOffsetY: 3,
            shadowBlur: 10,
            shadowColor: 'rgba(0, 0, 0, 0.5)',
          },
          scales: {
            xAxes: [
              {
                ticks: {
                  fontColor: '#979797',
                  fontFamily: 'ProximaNova-r',
                  fontSize: 13,
                },
                barPercentage: 1,
                gridLines: {
                  color: '#fff',
                },
              },
            ],
            yAxes: [
              {
                ticks: {
                  fontColor: '#979797',
                  fontFamily: 'ProximaNova-r',
                  fontSize: 13,
                },
                gridLines: {
                  color: '#f4f4f4',
                },
              },
            ],
          },
        }}
      />
    </Container>
  );
};

const mapStateToProps = (state) => ({
  currentSalonSign: selectCurrentSalonCurrencySign(state),
});

export default connect(mapStateToProps)(AvarageBillLineChart);
